(() => {
  class TheiaCollectionFilter {
    constructor(details) {
      this.details = details;
      this.summary = details.querySelector('summary');
      this.closeButton = details.querySelector('[data-theia-filter-close]');
      this.curtain = details.querySelector('[data-theia-filter-curtain]');
      this.panel = details.querySelector('[data-theia-filter-panel]');
      this.locked = false;
      this.closing = false;
      this.onToggle = () => this.sync();
      this.onClose = () => this.close();
      this.onSummaryClick = (event) => {
        if (!this.details.open) return;
        event.preventDefault?.();
        this.close();
      };
      this.onKey = (event) => {
        if (event.key !== 'Escape' || !this.details.open) return;
        event.preventDefault?.();
        this.close();
      };
      details.addEventListener('toggle', this.onToggle);
      this.summary?.addEventListener('click', this.onSummaryClick);
      this.closeButton?.addEventListener('click', this.onClose);
      this.curtain?.addEventListener('click', this.onClose);
    }

    sync() {
      const open = Boolean(this.details.open);
      if (open === this.locked) return;
      this.locked = open;
      document.documentElement?.classList?.toggle('theia-filter-open', open);
      document.body?.classList?.toggle('theia-filter-open', open);
      document.dispatchEvent(new CustomEvent('theia:page-scroll-lock', { detail: { locked: open } }));
      if (open) {
        this.details.classList.remove('is-closing');
        this.details.classList.remove('is-open');
        void this.panel?.offsetWidth;
        const reveal = () => {
          if (this.details.open && !this.closing) this.details.classList.add('is-open');
        };
        if (typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(reveal);
        else reveal();
        document.addEventListener('keydown', this.onKey);
        this.closeButton?.focus();
      } else {
        this.details.classList.remove('is-open');
        document.removeEventListener('keydown', this.onKey);
      }
    }

    close() {
      if (!this.details.open || this.closing) return;
      this.closing = true;
      this.details.classList.remove('is-open');
      this.details.classList.add('is-closing');
      const duration = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 1 : 480;
      window.setTimeout(() => {
        this.details.open = false;
        this.details.classList.remove('is-closing');
        this.closing = false;
        this.sync();
        this.summary?.focus();
      }, duration);
    }
  }

  const mount = (scope = document) => {
    scope.querySelectorAll('[data-theia-collection-filter]:not([data-theia-filter-mounted])').forEach((details) => {
      details.dataset.theiaFilterMounted = 'true';
      new TheiaCollectionFilter(details);
    });
  };

  window.TheiaCollectionFilter = TheiaCollectionFilter;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount());
  else mount();
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
})();
